<template>
  <svg
    width="10"
    height="14"
    viewBox="0 0 10 14"
  >
    <path d="M2 0H8C9.10457 0 10 0.89543 10 2V11.4969C10 11.7731 9.77614 11.9969 9.5 11.9969H1V12C1 12.5523 1.44772 13 2 13H9.5C9.77614 13 10 13.2239 10 13.5C10 13.7761 9.77614 14 9.5 14H2C0.895431 14 0 13.1046 0 12V2C0 0.895429 0.895431 0 2 0ZM1 2V10.9969H9V2C9 1.44772 8.55228 1 8 1H2C1.44771 1 1 1.44771 1 2Z" />
  </svg>
</template>